
const $body = $('body')
const searchBlock = $('.block-search')
$body.on('click', '.search-btn', function (e) {
  e.preventDefault()

  searchBlock.toggleClass('is-open')

  if(searchBlock.hasClass('is-open')) {
    searchBlock.find('input').focus()
  }

})

$body.on('click', '.search-btn-close', function (e) {
  e.preventDefault()

  searchBlock.removeClass('is-open')
})
